import appDownloadActionTypes from '../../constants/actions/idocmobile/appDownload'

export function sendMailAppDownload (platform) {
  return {
    type: appDownloadActionTypes.FETCH_SEND_MAIL_DOWNLOAD,
    platform
  }
}
